import {
  FormControl,
  FormHelperText,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
} from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

export const RefundReasonSelect = ({ desc, error, onRefundReasonChange }) => {
  const refundReasons = useSelector((state) => state?.static?.refundReasons);

  const isError = Boolean(error); // Vérification si une erreur existe
  const helperText = error || ''; // Texte d'erreur à afficher

  return (
    <FormControl
      variant="outlined"
      fullWidth
      error={isError} // Applique l'état d'erreur si nécessaire
    >
      <InputLabel htmlFor="refund-reason-select" shrink>
        Motif
      </InputLabel>
      <Select
        value={desc}
        onChange={(event) => onRefundReasonChange(event.target.value)}
        size="small"
        label="Motif"
        sx={{
          '& .MuiOutlinedInput-root': {
            paddingRight: '24px',
          },
        }}
      >
        {refundReasons?.reduce(
          (category, cat, idx) => [
            ...category,
            <ListSubheader
              sx={{ color: 'primary.main', fontWeight: 'bold' }}
              key={idx}
            >
              {cat?.service?.code}
            </ListSubheader>,
            ...cat.reasons.map((reason, idx) => (
              <MenuItem key={`${idx}-${reason}`} value={reason}>
                {reason}
              </MenuItem>
            )),
          ],
          []
        )}
      </Select>
      {/* Affichage de helperText sous le Select si erreur présente */}
      {isError && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
